import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'unixDate' })
export class UnixDatePipe implements PipeTransform {
  transform(value: number, format: string = 'dd.MM.yyyy'): string {
    if (!value) return '';
    return new Intl.DateTimeFormat('ru-RU').format(new Date(value * 1000));
  }
}
